import React from "react";
import OrderService from "services/order";

import { connect } from "react-redux";
import { load } from "reducers/order";

class Order extends React.Component {
  orderService = new OrderService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.orderService.getAll().then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Order);
